import { useTranslations } from '@vocab/react';
import { ButtonLink, Inline } from 'braid-design-system';
import { useContext } from 'react';

import { EmptyBoxSvg } from 'src/SVG';
import AnalyticsContext from 'src/analytics/AnalyticsContext';
import type { RecommendedJobsAnalytics } from 'src/analytics/adapter/recommendedJobs';
import ResultTemplate from 'src/components/Recommendations/ResultTemplate/ResultTemplate';

import translations from './.vocab';

const RecommendationActions = () => {
  const { profileViewed } = useContext(
    AnalyticsContext,
  ) as RecommendedJobsAnalytics;
  const { t } = useTranslations(translations);
  return (
    <Inline space="small" align="center">
      <ButtonLink
        href="/profile"
        variant="ghost"
        onClick={() => {
          profileViewed();
        }}
        tone="formAccent"
      >
        {t('Review your profile')}
      </ButtonLink>
      <ButtonLink href="/" variant="ghost" tone="formAccent">
        {t('Start a new search')}
      </ButtonLink>
    </Inline>
  );
};

const ZeroRecommendations = () => {
  const { t } = useTranslations(translations);
  return (
    <ResultTemplate
      heading={t('You have no recommended jobs')}
      description={t('Discover new opportunities based on...')}
      Actions={RecommendationActions}
      data-automation="zeroRecsContainer"
      Illustration={EmptyBoxSvg}
    />
  );
};

export default ZeroRecommendations;
